module.exports = __webpack_public_path__ + "static/media/birthday-cake.882e6471.png";